angular.module('unergie.main')
.directive('keyboardListener', ($timeout) =>
    ({
        restrict: 'A',
        link(scope, elem, attrs) {
            const config = scope.$eval(attrs.keyboardListener)
            const buffer = {}
            const processCombo = () =>
                _.forEach(config, (conf) => {
                    let combo = true
                    _.forEach(conf.combo, (key) => {
                        if (!buffer[key]) {
                            combo = false
                        }
                    })
                    if (combo) {
                        conf.func(conf.data)
                    }
                })


            elem.on('keydown', ($event) => {
                buffer[$event.keyCode] = 1
                return processCombo()
            })

            elem.on('keyup', ($event) => {
                buffer[$event.keyCode] = 0
            })
        },
    })
)
